'use client';

import { useCreateMediaFilter } from '@/hooks/useCreateMediaFilter';

type Props = {
  imageUrl: string | undefined;
  mediaId: number | undefined;
  filterName: string;
};

export default function CreateMediaFilterTrigger({
  imageUrl,
  mediaId,
  filterName,
}: Props) {
  useCreateMediaFilter({ imageUrl, mediaId, filterName });

  return null;
}
